import React, { useState } from 'react';
import {
    Box,
    Typography,
    TextField,
    Button,
    Link,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import logo from '../../assets/images/gameup_dark.png';
import RequestService from '../../services/RequestService';

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState(null);
    const [emailSent, setEmailSent] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);

        try {
            await RequestService.forgotPassword(email);
            setEmailSent(true);
        } catch (err) {
            setError('Erro ao enviar o e-mail. Tente novamente.');
        }
    };

    return (
        <Box
            sx={{
                height: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#FFFFFF',
                padding: 2,
            }}
        >
            <Box
                sx={{
                    width: isMobile ? '90%' : '400px',
                    padding: isMobile ? 3 : 4,
                    borderRadius: 2,
                    textAlign: 'center',
                    backgroundColor: '#FFFFFF',
                }}
            >
                <Box
                    component="img"
                    src={logo}
                    alt="Logo"
                    sx={{
                        width: isMobile ? 195 : 227,
                        marginBottom: isMobile ? '32px' : '40px',
                    }}
                />
                {!emailSent ? (
                    <>
                        <Typography
                            sx={{
                                fontFamily: 'Poppins',
                                fontSize: '24px',
                                fontWeight: 500,
                                color: '#292929',
                                marginBottom: 1,
                            }}
                        >
                            Esqueceu sua senha?
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: 'Poppins',
                                fontSize: '14px',
                                fontWeight: 400,
                                color: '#666666',
                                marginBottom: 3,
                            }}
                        >
                            Insira seu e-mail no campo abaixo e receba um link
                            para redefini-la.
                        </Typography>

                        <TextField
                            label="E-mail"
                            placeholder="seu e-mail da GameUP."
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            fullWidth
                            sx={{ marginBottom: 2 }}
                        />

                        <Button
                            fullWidth
                            variant="contained"
                            sx={{
                                mb: '24px',
                                fontSize: '16px',
                                fontWeight: '500',
                                minHeight: '40px',
                                backgroundColor: '#1F83FF',
                                '&:hover': {
                                    backgroundColor: '#1565C0',
                                },
                            }}
                            onClick={handleSubmit}
                        >
                            Enviar link mágico
                        </Button>

                        <Link
                            href="/login"
                            sx={{
                                display: 'block',
                                textAlign: 'center',
                                color: '#1F83FF',
                                fontSize: '14px',
                                fontWeight: '400',
                                '&:hover': { textDecoration: 'underline' },
                            }}
                        >
                            Voltar
                        </Link>
                    </>
                ) : (
                    <>
                        <Typography
                            sx={{
                                fontFamily: 'Poppins',
                                fontSize: '24px',
                                fontWeight: 500,
                                color: '#292929',
                                marginBottom: 1,
                            }}
                        >
                            E-mail enviado com sucesso!
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: 'Poppins',
                                fontSize: '14px',
                                fontWeight: 400,
                                color: '#666666',
                                marginBottom: 3,
                            }}
                        >
                            Se você não encontrou em sua caixa de entrada,
                            verifique sua caixa de spam. Caso o e-mail ainda não
                            tenha chegado, entre em contato com o suporte.
                        </Typography>

                        <Button
                            fullWidth
                            variant="contained"
                            sx={{
                                mb: '24px',
                                fontSize: '16px',
                                fontWeight: '500',
                                minHeight: '40px',
                                backgroundColor: '#1F83FF',
                                '&:hover': {
                                    backgroundColor: '#1565C0',
                                },
                            }}
                            onClick={() => (window.location.href = '/login')}
                        >
                            Voltar para o login
                        </Button>
                    </>
                )}
            </Box>
        </Box>
    );
};

export default ForgotPasswordPage;
